import React from 'react';
import { Modal, Field, ModalFooter } from './modalComponents';  // Changé
import { FUEL_META } from './constants';  // Changé
import { fmtUSD } from './formatters';  // Changé

const PriceModal = ({ isOpen, onClose, priceForm, setPriceForm, inventory, onSave, saving }) => {
  if (!isOpen) return null;

  return (
    <Modal title="Update Fuel Price" onClose={onClose}>
      <div className="space-y-3">
        <Field label="Fuel type">
          <select 
            value={priceForm.fuel_type} 
            onChange={e => {
              const inv = inventory.find(i => i.fuel_type === e.target.value);
              setPriceForm({ fuel_type: e.target.value, price_per_gallon: inv?.price_per_gallon || '' });
            }} 
            className="w-full bg-gray-700 border border-gray-600 rounded-lg p-2 text-white text-sm"
          >
            {inventory.map(i => (
              <option key={i.fuel_type} value={i.fuel_type}>
                {FUEL_META[i.fuel_type]?.label || i.fuel_type} — current: {fmtUSD(i.price_per_gallon)}/gal
              </option>
            ))}
          </select>
        </Field>
        <Field label="New retail price ($/gallon) *">
          <input 
            type="number" 
            min="0" 
            step="0.001"
            value={priceForm.price_per_gallon}
            onChange={e => setPriceForm(prev => ({ ...prev, price_per_gallon: e.target.value }))}
            className="w-full bg-gray-700 border border-gray-600 rounded-lg p-2 text-white text-sm" 
          />
        </Field>
      </div>
      <ModalFooter 
        onCancel={onClose} 
        onSave={onSave}
        saving={saving} 
        disabled={!priceForm.price_per_gallon} 
        label="Update Price" 
      />
    </Modal>
  );
};

export default PriceModal;